<template>
  <!-- 预警事件处理排行 -->
  <div class="warn-rank">
    <yq-empty description="暂无数据" v-if="data.length === 0" style="padding: 0"/>
    <div v-for="(item, i) in data" :key="i" class="rank-item">
      <div class="rank-num">
        <yq-icon name="hexagon-fill" class="bg" rotate-z="30deg"/>
        <yq-number class="num" :value="'0' + (i+1)"/>
      </div>
      <div class="rank-name">
        <div class="name">{{item.buildingName}}</div>
        <div class="count">{{item.count}}{{unitName}}</div>
      </div>
    </div>
  </div>
</template>

<script>

import {useRoute, useRouter} from "vue-router";
import YqNumber from "@/components/YqNumber.vue";
import YqIcon from "@/components/YqIcon.vue";

export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  props: {
    data: {default: []}, // 数据，格式：[{buildingName: "xxxx", count: 0}]
    unitName: {default: ""}, // 单位名称
  },
  name: "WarnRank",
  components: {
    YqIcon,
    YqNumber
  },
  data() {
    return {
    };
  },
  created() {
  },
  methods: {

  }
};
</script>

<style lang="scss" scoped>
.warn-rank{
  .rank-item{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .rank-num{
      position: relative;
      margin-right: 10px;
      overflow: hidden;
      text-align: center;
      width: 36px;
      height: 36px;
      line-height: 36px;
      margin-bottom: 10px;
      .bg{
        // 文本渐变
        position: absolute;
        color: transparent;
        background-image: linear-gradient(to top, #70e8f8, #57cede);
        background-clip: text;
        font-size: 40px;
        left: -2px;
        top: 0;
        opacity: .7;
      }
      .num{
        position: relative;
        z-index: 1;
        font-size: 12px;
        color: #FFF;
      }
    }
    .rank-name{
      .count{
        color: var(--map-color-text);
        font-size: 12px;
      }
    }
  }
}
</style>